export default {
  // Navigation
  nav_categories: "Catégories",
  nav_guides: "Guides",
  nav_reviews: "Avis",
  nav_shipping: "Livraison",
  nav_about: "À propos",
  nav_contact: "Contact",
  nav_language: "Langue",

  // Hero Section
  hero_h1: "AllChinaBuy Spreadsheet — Trouvez des produits, comparez les options et achetez plus intelligemment",
  hero_subtitle: "Explorez les ressources de feuille de calcul AllChinaBuy, les découvertes de produits, les guides de contrôle qualité, les informations sur la livraison, les avis et les comparaisons — organisés dans un centre de ressources facile à utiliser.",
  hero_cta_primary: "Explorer AllChinaBuy Spreadsheet",
  hero_cta_secondary: "Acheter maintenant",
  hero_search_placeholder: "Rechercher AllChinaBuy spreadsheet, produits, livraison, QC ou guides...",

  // Category Section
  categories_title: "Catégories populaires",
  categories_subtitle: "Parcourez nos catégories de produits sélectionnées et trouvez les meilleures offres sur AllChinaBuy",
  category_shoes: "Chaussures",
  category_hoodies: "Sweats à capuche / Pulls",
  category_tshirts: "T-Shirts",
  category_jackets: "Vestes",
  category_pants: "Pantalons / Shorts",
  category_headwear: "Couvre-chefs",
  category_sets: "Ensembles",
  category_underwear: "Sous-vêtements",
  category_jersey: "Maillots",
  category_accessories: "Accessoires",
  category_bags: "Sacs",
  category_belts: "Ceintures",
  category_perfumes: "Parfums",
  category_other: "Autres articles",
  category_button: "Tout parcourir",

  // Articles Section
  articles_title: "Derniers guides et ressources",
  articles_subtitle: "Articles approfondis pour vous aider à mieux acheter sur AllChinaBuy",
  article_read_more: "Lire le guide",
  article_read_time: "min de lecture",
  article_allchinabuy_spreadsheet_guide: "Guide complet AllChinaBuy Spreadsheet",
  article_allchinabuy_spreadsheet_guide_desc: "Le guide ultime pour utiliser AllChinaBuy spreadsheet pour trouver des produits, comparer les prix et faire des achats éclairés en 2026.",
  article_allchinabuy_review: "Avis AllChinaBuy 2026",
  article_allchinabuy_review_desc: "Avis complet couvrant les fonctionnalités, les frais, les options de livraison, le support client et les expériences réelles des utilisateurs.",
  article_shipping_cost: "Guide des coûts de livraison AllChinaBuy",
  article_shipping_cost_desc: "Détail complet des méthodes de livraison, des coûts par pays et des conseils pour réduire vos dépenses de livraison.",
  article_allchinabuy_coupon: "Coupons et codes de réduction AllChinaBuy",
  article_allchinabuy_coupon_desc: "Coupons actuels, codes de réduction et conseils pour économiser de l'argent pour les acheteurs AllChinaBuy.",
  article_allchinabuy_vs: "AllChinaBuy vs concurrents",
  article_allchinabuy_vs_desc: "Comparaison détaillée d'AllChinaBuy avec Superbuy, CSSBuy, Sugargoo et Pandabuy.",
  article_allchinabuy_legit: "AllChinaBuy est-il fiable?",
  article_allchinabuy_legit_desc: "Guide de sécurité couvrant la sécurité des paiements, les processus de contrôle qualité, le stockage en entrepôt et comment éviter les arnaques.",
  article_allchinabuy_qc: "Guide de contrôle qualité AllChinaBuy",
  article_allchinabuy_qc_desc: "Comment utiliser le service de contrôle qualité d'AllChinaBuy pour inspecter vos articles avant la livraison internationale.",
  article_allchinabuy_warehouse: "Guide de l'entrepôt AllChinaBuy",
  article_allchinabuy_warehouse_desc: "Comprendre le stockage en entrepôt, l'inspection et les services de consolidation chez AllChinaBuy.",

  // CTA Section
  cta_title: "Prêt à explorer AllChinaBuy?",
  cta_subtitle: "Recherchez d'abord. Comparez les options. Prenez des décisions mieux informées.",
  cta_button: "AllChinaBuy Spreadsheet",
  cta_button_secondary: "Acheter maintenant",

  // FAQ Section
  faq_title: "Questions fréquemment posées",
  faq_1_q: "Qu'est-ce que AllChinaBuy Spreadsheet?",
  faq_1_a: "AllChinaBuy Spreadsheet est une collection organisée de liens de produits, de prix et d'informations sur les vendeurs dans un format facile à utiliser. Il aide les acheteurs à trouver les meilleures offres sur les chaussures, vêtements, accessoires et plus encore sur les plateformes de shopping chinoises.",
  faq_2_q: "AllChinaBuy est-il sûr à utiliser?",
  faq_2_a: "AllChinaBuy met en œuvre des mesures de sécurité standard incluant les paiements cryptés, les contrôles de qualité en entrepôt et les politiques de protection des acheteurs. Cependant, comme pour tout service de shopping international, nous recommandons de rechercher les vendeurs et d'utiliser le service de contrôle qualité (QC) avant d'expédier les articles internationalement.",
  faq_3_q: "Combien coûte la livraison AllChinaBuy?",
  faq_3_a: "Les coûts de livraison varient selon le pays de destination, le poids du colis et le mode de livraison. AllChinaBuy propose plusieurs lignes de livraison incluant EMS, DHL, FedEx et des options économiques. Utilisez notre guide de calcul de livraison pour estimer les coûts pour votre commande spécifique.",
  faq_4_q: "AllChinaBuy offre-t-il des coupons ou des codes de réduction?",
  faq_4_a: "Oui, AllChinaBuy fournit régulièrement des coupons et des codes promotionnels pour les nouveaux et les clients existants. Consultez notre guide de coupons pour les codes actifs actuels et les stratégies d'économie.",
  faq_5_q: "Comment AllChinaBuy se compare-t-il aux autres agents de shopping?",
  faq_5_a: "AllChinaBuy offre des tarifs de livraison compétitifs, une interface conviviale et des ressources de feuilles de calcul complètes. Par rapport à Superbuy, CSSBuy et Sugargoo, AllChinaBuy se distingue par ses feuilles de calcul de produits organisées et sa structure de frais simple. Lisez nos guides de comparaison détaillés pour plus d'informations.",
  faq_6_q: "Vers quels pays AllChinaBuy livre-t-il?",
  faq_6_a: "AllChinaBuy livre dans la plupart des pays du monde, y compris les États-Unis, le Royaume-Uni, le Canada, l'Allemagne, la France, le Danemark, l'Australie et à travers l'Europe. Les délais et les coûts de livraison varient selon la destination.",
  faq_7_q: "Puis-je obtenir un remboursement si ma commande est incorrecte?",
  faq_7_a: "AllChinaBuy propose des options de remboursement et de retour selon la politique du vendeur et l'étape de votre commande. Les articles qui n'ont pas été expédiés de l'entrepôt peuvent généralement être retournés. Une fois expédiés internationalement, les retours deviennent plus complexes et peuvent impliquer des frais supplémentaires.",
  faq_8_q: "Comment utiliser le spreadsheet AllChinaBuy?",
  faq_8_a: "Utiliser le spreadsheet AllChinaBuy est simple : parcourez les catégories, cliquez sur les liens de produits pour voir les articles, ajoutez les produits souhaités à votre panier et procédez au processus d'achat. Notre guide complet fournit des instructions étape par étape avec des captures d'écran.",

  // Footer
  footer_title: "AllChinaBuy Spreadsheet",
  footer_desc: "Votre ressource de confiance pour la recherche de produits AllChinaBuy, les avis et les guides d'achat. Nous vous aidons à prendre des décisions éclairées lors de vos achats en Chine.",
  footer_links: "Liens rapides",
  footer_resources: "Ressources",
  footer_legal: "Mentions légales",
  footer_privacy: "Politique de confidentialité",
  footer_terms: "Conditions d'utilisation",
  footer_disclaimer: "Avertissement",
  footer_contact: "Contactez-nous",
  footer_copyright: "AllChinaBuy Spreadsheet. Tous droits réservés. Cette ressource est indépendante et n'est pas affiliée ou exploitée par AllChinaBuy sauf indication explicite.",

  // Article Page
  article_back_home: "Retour à l'accueil",
  article_toc: "Table des matières",
  article_last_updated: "Dernière mise à jour",
  article_author: "Auteur",
  article_reading_time: "Temps de lecture",
  article_related: "Articles connexes",
  article_faq_title: "Questions fréquemment posées",
  article_share: "Partager ce guide",
  article_cta_text: "Prêt à commencer vos achats avec AllChinaBuy?",
  article_cta_button: "Explorer AllChinaBuy Spreadsheet",
  article_cta_button_buy: "Acheter maintenant",

  // About Page
  about_title: "À propos de AllChinaBuy Spreadsheet",
  about_desc: "Nous sommes un centre de ressources indépendant dédié à aider les acheteurs à naviguer dans le monde des agents de shopping chinois. Notre mission est de fournir des informations transparentes, précises et utiles sur AllChinaBuy et les services connexes.",
  about_mission: "Notre mission",
  about_mission_desc: "Donner aux acheteurs internationaux les connaissances et les outils nécessaires pour prendre des décisions d'achat en toute confiance lorsqu'ils utilisent AllChinaBuy et des services d'agent de shopping similaires.",
  about_vision: "Notre vision",
  about_vision_desc: "Devenir la ressource indépendante la plus fiable pour les acheteurs AllChinaBuy dans le monde entier, couvrant tous les aspects de l'expérience d'achat, de la recherche de produits à la livraison.",
  about_values: "Nos valeurs",
  about_values_transparency: "Transparence dans tous nos avis et comparaisons",
  about_values_accuracy: "Informations précises et à jour",
  about_values_independence: "Indépendance de toute entreprise d'agent de shopping",
  about_values_helpfulness: "Contenu utile qui résout de vrais problèmes",

  // Contact Page
  contact_title: "Contactez-nous",
  contact_desc: "Vous avez des questions sur AllChinaBuy? Nous sommes là pour vous aider. Contactez notre équipe pour des demandes, des suggestions ou des opportunités de collaboration.",
  contact_form_name: "Votre nom",
  contact_form_email: "Adresse e-mail",
  contact_form_subject: "Sujet",
  contact_form_message: "Message",
  contact_form_submit: "Envoyer le message",
  contact_info: "Informations de contact",
  contact_response: "Nous répondons généralement dans les 24 à 48 heures.",

  // Breadcrumb
  breadcrumb_home: "Accueil",
  breadcrumb_article: "Article",
  breadcrumb_about: "À propos",
  breadcrumb_contact: "Contact",
};